// Storage manager
class Storage {
  constructor() {
    this.storage = window.localStorage;
  }

  getItem(name) {
    return this.storage.getItem(name);
  }

  setItem(name, data) {
    this.storage.setItem(name, data);
  }

  removeItem(name) {
    this.storage.removeItem(name);
  }
}

export default new Storage();
